// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Page-root-q_n_Z {
  padding-left: 20px;
  padding-right: 20px;
}

.Page-container-uko9c {
  margin: 0 auto;
  padding: 0 0 40px;
  max-width: var(--max-content-width);
}

.Page-previewPageWrapper-tKRFS {
  min-height: 600px;
}

@media (max-width: 1199px) and (min-width: 768px) {
  .Page-previewPageWrapper-tKRFS {
    min-height: 350px;
  }
}

@media (max-width: 767px) {
  .Page-previewPageWrapper-tKRFS {
    min-height: 250px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Page/Page.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".root {\n  padding-left: 20px;\n  padding-right: 20px;\n}\n\n.container {\n  margin: 0 auto;\n  padding: 0 0 40px;\n  max-width: var(--max-content-width);\n}\n\n.previewPageWrapper {\n  min-height: 600px;\n}\n\n@media (max-width: 1199px) and (min-width: 768px) {\n  .previewPageWrapper {\n    min-height: 350px;\n  }\n}\n\n@media (max-width: 767px) {\n  .previewPageWrapper {\n    min-height: 250px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Page-root-q_n_Z`,
	"container": `Page-container-uko9c`,
	"previewPageWrapper": `Page-previewPageWrapper-tKRFS`
};
module.exports = ___CSS_LOADER_EXPORT___;
